import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  Input,
  Tabs,
  InputDropdown,
  Spinner,
} from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInputComponent from "../PhoneInputComponent";

const userStatusList = [
  {
    option: "Pending",
    id: "0",
  },
  {
    option: "Active",
    id: "1",
  },
  {
    option: "Rejected",
    id: "2",
  },
];

const UpdateUserProfile = ({
  getCurrentUser,
  onSubmitDetails,
  loading,
  resetPassword,
  onSubmitUserStatus,
  userStatus,
  createUserState,
  id,
  roles,
  userloader,
  onSubmitPasswordChange,
  passLoader,
  pathName,
  selfUpdate,
}) => {
  const [roleState, setRoleState] = useState();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [userProfileImage, setUserProfileImage] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [status, setUserStatus] = useState();
  const [statusValue, setStatusValue] = useState([]);

  const userId = getCurrentUser?.id;

  const userStatusRef = useRef("");
  const adminPasswordRef = useRef("");
  const newPasswordRef = useRef("");
  const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const phoneRegExp = /^\+[0-9]{10,16}/;
  const formik = useFormik({
    initialValues: {
      name: getCurrentUser ? getCurrentUser?.name : "",
      surname: getCurrentUser ? getCurrentUser?.surname : "",
      title: getCurrentUser ? getCurrentUser?.title : "",
      city: getCurrentUser ? getCurrentUser?.city : "",
      state: getCurrentUser ? getCurrentUser?.state : "",
      address: getCurrentUser ? getCurrentUser?.address : "",
      phoneNumber: getCurrentUser?.phoneNumber ? getCurrentUser?.phoneNumber : "",
      ...(selfUpdate && {
        roleNames: getCurrentUser ? getCurrentUser?.role : "",
      }),
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter your name."),
      surname: Yup.string().required("Please enter your surname."),
      ...(phoneNumber?.length < 2 ? {
        phoneNumber: Yup.string(),
        // .matches(phoneRegExp, "Phone number is not valid"),
        // .required("Please enter your phone number"),
      } : {
        phoneNumber: Yup.string()
          .matches(phoneRegExp, "Phone number is not valid"),
        // .required("Please enter your phone number"),
      }),
      ...(selfUpdate && {
        roleNames: Yup.string().required("Please select a role"),
      }),
    }),
    onSubmit: (values) => {
      const newValues = {
        ...values,
        profileImage: userProfileImage ? userProfileImage : "",
        phoneNumber: phoneNumber.length > 2 ? phoneNumber : "",
        id: id ? id : "",
      };
      const editUser = {
        ...values,
        profileImage: userProfileImage ? userProfileImage : "",
        phoneNumber: phoneNumber.length > 2 ? phoneNumber : "",
      };
      const formData = new FormData();
      if (pathName === "/user") {
        Object.keys(editUser).map((item) =>
          formData.append(`${item}`, editUser[`${item}`])
        );
      } else {
        Object.keys(newValues).map((item) =>
          formData.append(`${item}`, newValues[`${item}`])
        );
      }
      onSubmitDetails(formData);
      formik.resetForm();
    },
  });

  useEffect(() => {
    if (getCurrentUser?.profileImage) {
      setUserProfileImage(getCurrentUser?.profileImage);
    }
    if (getCurrentUser?.status) {
      setUserStatus(getCurrentUser?.status);
    }
  }, [getCurrentUser?.profileImage, getCurrentUser?.status]);

  useEffect(() => {
    setStatusValue(getCurrentUser?.status);
  }, [getCurrentUser?.status]);

  const handleStatusChange = (ref, e) => {
    setUserStatus(e.target.value);
    ref.current = e.target.value;
  };

  const handleProfileImageChange = (e) => {
    var reader = new FileReader();
    reader.onload = function () {
      var output = document.getElementById("output_image");
      output.src = reader.result;
    };
    setUserProfileImage(e.target.files[0]);
    reader.readAsDataURL(e.target.files[0]);
  };

  const onSubmitStatus = () => {
    if (status !== undefined) {
      onSubmitUserStatus({ id: userId, status: status });
    }
  };

  const getUserStatus = () => {
    const status = userStatusList[statusValue]?.option;
    return status;
  };
  const formikPassword = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("Please enter your Current Password."),
      newPassword: Yup.string()
        .matches(passwordRegExp,
          "Minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number and 1 special character required")
        .required("Please enter your New Password."),
    }),
    onSubmit: (values) => {
      const newValues = {
        ...values
      };
      onSubmitPasswordChange(newValues);
    },
  })
  return (
    <main>
      <div className="main-inner">
        <div className="container mt-5">
          {loading ? (
            <Spinner className="text-center" />
          ) : (
            <div
              className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large
          "
            >
              <div className="box-lg">
                <ul
                  className="nav nav-tabs hf-nav-tabs2"
                  id="myTab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <Tabs
                      tabType="primary"
                      controls="profile"
                      ariaSelected="true"
                      target="#profile"
                      tabName="Profile"
                      id="profile-tab"
                    />
                  </li>
                  {resetPassword && (
                    <li className="nav-item" role="presentation">
                      <Tabs
                        controls="reset-password"
                        ariaSelected="false"
                        target="#reset-password"
                        tabName="Update Password"
                        id="reset-password-tab"
                      />
                    </li>
                  )}
                  {userStatus && (
                    <li className="nav-item" role="presentation">
                      <Tabs
                        controls="user-status"
                        ariaSelected="false"
                        target="#user-status"
                        tabName="User Status"
                        id="user-status-tab"
                      />
                    </li>
                  )}
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="box-lg mt-5">
                    <div className="edit-profile-picture mx-auto">
                      <img
                        id="output_image"
                        src={
                          userProfileImage
                            ? userProfileImage
                            : "./assets/images/empty-avatar.png"
                        }
                        alt=""
                      />

                      <div className="edit-btn">
                        <Input
                          type="file"
                          onChange={handleProfileImageChange}
                          name="image"
                          accept="image/*"
                          props
                        />
                      </div>
                    </div>
                    <div className="mt-5">
                      <div className="row g-4">
                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="Name"
                            id="name"
                            label="Name"
                            forr="name"
                            props
                            {...formik.getFieldProps("name")}
                          />
                          {formik.touched.name && formik.errors.name ? (
                            <div className="form-error-message">
                              {formik.errors.name}
                            </div>
                          ) : null}
                        </div>

                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="Last Name"
                            id="surname"
                            label="Last Name"
                            forr="surname"
                            props
                            {...formik.getFieldProps("surname")}
                          />
                          {formik.touched.surname && formik.errors.surname ? (
                            <div className="form-error-message">
                              {formik.errors.surname}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="Title"
                            id="title"
                            label="Title"
                            forr="title"
                            props
                            {...formik.getFieldProps("title")}
                          />
                          {formik.touched.title && formik.errors.title ? (
                            <div className="form-error-message">
                              {formik.errors.title}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="City"
                            id="city"
                            label="City"
                            forr="city"
                            props
                            {...formik.getFieldProps("city")}
                          />
                          {formik.touched.city && formik.errors.city ? (
                            <div className="form-error-message">
                              {formik.errors.city}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="State"
                            id="state"
                            label="State"
                            forr="state"
                            props
                            {...formik.getFieldProps("state")}
                          />
                          {formik.touched.state && formik.errors.state ? (
                            <div className="form-error-message">
                              {formik.errors.state}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-6">
                          <Input
                            type="text"
                            placeholder="Address"
                            id="address"
                            label="Address"
                            forr="address"
                            props
                            {...formik.getFieldProps("address")}
                          />
                          {formik.touched.address && formik.errors.address ? (
                            <div className="form-error-message">
                              {formik.errors.address}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-md-6 phone-col">
                          <PhoneInputComponent
                            country={"us"}
                            placeholder="Phone Number"
                            {...formik.getFieldProps("phoneNumber")}
                            onChange={(phone) => {
                              formik.setFieldValue("phoneNumber", `+${phone}`);
                              setPhoneNumber(`+${phone}`);
                            }}
                          />
                          {formik.touched.phoneNumber &&
                            formik.errors.phoneNumber ? (
                            <div className="form-error-message">
                              {formik.errors.phoneNumber}
                            </div>
                          ) : null}
                        </div>
                        {selfUpdate && (
                          <div className="col-md-6 role-names">
                            <select
                              className={"form-select field-white "}
                              onChange={(e) => {
                                setRoleState(e.target.value);
                              }}
                              {...formik.getFieldProps("roleNames")}
                            >
                              <option selected disabled hidden>
                                Role Names
                              </option>
                              {roles?.map((item, index) => {
                                return (
                                  <option key={index} value={item?.name}>
                                    {item?.name}
                                  </option>
                                );
                              })}
                            </select>
                            {formik.touched.roleNames && formik.errors.roleNames ? (
                              <div className="form-error-message">
                                {formik.errors.roleNames}
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>

                      <div className="text-center mt-5">
                        <Button
                          btnName="Save"
                          btnType="primary"
                          onClick={() => {
                            formik.handleSubmit();
                          }}
                          loading={loading || createUserState || userloader}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {resetPassword && (
                  <div
                    className="tab-pane fade"
                    id="reset-password"
                    role="tabpanel"
                    aria-labelledby="reset-password-tab"
                  >
                    <div className="box-sm mt-5">
                      <div className="row g-4">
                        <div className="col-12">
                          <Input
                            type={showOldPassword ? "text" : "password"}
                            id="currentPassword"
                            placeholder="Current Password"
                            label="Current Password"
                            forr="currentPassword"
                            required
                            eyeVisibility={
                              showOldPassword ? "fa fa-eye" : "fa fa-eye-slash"
                            }
                            onClick={() => {
                              setShowOldPassword(!showOldPassword);
                            }}
                            props
                            {...formikPassword.getFieldProps("currentPassword")}
                          />
                          {formikPassword.touched.currentPassword && formikPassword.errors.currentPassword ? (
                            <div className="form-error-message">
                              {formikPassword.errors.currentPassword}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-12">
                          <Input
                            type={showNewPassword ? " text" : "password"}
                            id="newPassword"
                            placeholder="New Password"
                            label="New Password"
                            forr="newPassword"
                            required
                            eyeVisibility={
                              showNewPassword ? "fa fa-eye" : "fa fa-eye-slash"
                            }
                            onClick={() => {
                              setShowNewPassword(!showNewPassword);
                            }}
                            props
                            {...formikPassword.getFieldProps("newPassword")}
                          />
                          {formikPassword.touched.newPassword && formikPassword.errors.newPassword ? (
                            <div className="form-error-message">
                              {formikPassword.errors.newPassword}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="text-center mt-5">
                      {/* <Button btnName="Cancel" btnType="!primary" /> */}
                      <Button
                        btnName="Save"
                        btnType="primary"
                        loading={passLoader}
                        onClick={() => {
                          formikPassword.handleSubmit();
                        }}
                      />
                    </div>
                  </div>
                )}
                {userStatus && (
                  <div
                    className="tab-pane fade"
                    id="user-status"
                    role="tabpanel"
                    aria-labelledby="user-status-tab"
                  >
                    <div className="box-sm mt-5">
                      <div className="row g-4">
                        <div className="col-12 pb-5">
                          <InputDropdown
                            customClass="form-select-custom"
                            inputDropdownOptions={
                              userStatusList ? userStatusList : {}
                            }
                            defaultValue={getUserStatus()}
                            onChange={(e) => {
                              handleStatusChange(userStatusRef, e);
                            }}
                            id="userStatus"
                            valueWithId="id"
                            ref={userStatusRef}
                            value={getUserStatus()}
                          />
                        </div>
                        <div className="text-center mt-5">
                          <Button
                            btnName="Save"
                            type="submit"
                            btnType="primary"
                            onClick={onSubmitStatus}
                            loading={createUserState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default UpdateUserProfile;
